/** @file Multi-line JSON value for schema shapes without a dedicated control; commits on blur. */
import { useState } from 'react';

/** Props of JsonField; `label` is the API field name. */
export interface JsonFieldProps {
  label: string;
  value: string;
  onCommit: (text: string) => void;
}

/** A textarea with a local draft; the form parses the text when it builds the input. */
export function JsonField({ label, value, onCommit }: JsonFieldProps) {
  const [draft, setDraft] = useState<string | null>(null);
  return (
    <label className="p2-form-row">
      <span className="p2-form-label">{label}</span>
      <textarea className="p2-form-json" aria-label={label} rows={3} spellCheck={false} value={draft ?? value}
        onChange={(e) => { setDraft(e.currentTarget.value); }}
        onBlur={() => { if (draft !== null && draft !== value) onCommit(draft); setDraft(null); }} />
    </label>
  );
}
